import { render, staticRenderFns } from "./search-query-ranking-list.view.vue?vue&type=template&id=6e83b8fc"
import script from "./search-query-ranking-list.view.vue?vue&type=script&lang=ts"
export * from "./search-query-ranking-list.view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports